import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

/**
 * REGEL: Alles, was im ersten Aufbau Browser-Speicher (localStorage/sessionStorage),
 * Fenstergröße oder zwischengespeicherte Daten liest, erst nach dem Start im Browser
 * anzeigen. Der Server kennt diese Werte nicht; sonst weicht der erste Browser-Aufbau
 * vom Server-HTML ab und React baut die ganze Seite neu auf.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
}
